import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a263f3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a263f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a263f3e')) {
      api.createRecord('6a263f3e', component.options)
    } else {
      api.reload('6a263f3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a263f3e&scoped=true", function () {
      api.rerender('6a263f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSetting/wxAccount/reply/keyword/index.vue"
export default component.exports